import projectData from '@/stores/projectData';

export const SET_SHARE_DATA = 'SET_SHARE_DATA';

export default {
	data: () => ({
		selfShareData: null,
	}),
	computed: {
		pageShareData() {
			return (this as any).selfShareData || projectData().shareData;
		},
	},
	onShow() {
		uni.$on(SET_SHARE_DATA, (data: any) => {
			(this as any).selfShareData = data;
		});
	},
	onHide() {
		uni.$off(SET_SHARE_DATA);
	},
	onReachBottom() {
		uni.$emit('onBottom');
	},
	onShareAppMessage() {
		return (this as any).pageShareData;
	},
};
